import React, { forwardRef, memo } from 'react';
import { MediaItem } from '../../stores/reducers/media';

interface MediaAudioProps {
	id: string;
	mediaItem: MediaItem | undefined;
	duration?: number;
	elapsed: number;
	loop?: boolean;
	muted?: boolean;
	shownVolume?: number | null;
	onEnded?: () => void;
	onError?: (error: any) => void;
	onPlay?: () => void;
	onLoadStart?: () => void;
	onTimeUpdate?: () => void;
	onLoadedData?: () => void;
}

const MediaAudio = forwardRef((
	{
		id,
		mediaItem,
		duration,
		elapsed,
		loop,
		muted,
		shownVolume = 1,
		onEnded,
		onError,
		onPlay,
		onLoadStart,
		onTimeUpdate,
		onLoadedData,
	}: MediaAudioProps,
	ref: React.Ref<HTMLAudioElement>,
) => {
	if (!mediaItem) {
		return (
			<></>
		);
	}

	const getAudioMimeType = (type: string) => {
		switch (type) {
			case 'aac':
				return 'audio/aac';
			case 'mp3':
				return 'audio/mpeg';
			case 'wav':
				return 'audio/wav';
			default:
				return '';
		}
	};

	return (
		<audio
			id={id}
			ref={ref}
			className="media-audio"
			onPlay={onPlay}
			onEnded={onEnded}
			onError={(error) => {
				if (onError) {
					onError(error);
				}
			}}
			loop={loop}
			controls={true}
			onLoadStart={onLoadStart}
			onTimeUpdate={onTimeUpdate}
			onLoadedData={onLoadedData}
			crossOrigin={'anonymous'}
		>
			<source
				src={mediaItem.images}
				type={getAudioMimeType(mediaItem?.type ?? '')}
			/>
		</audio>
	);
});

MediaAudio.displayName = 'MediaAudio';

export default memo(MediaAudio);
